import { ReactElement } from 'react';

import { AppointmentUpdatePatientPresenceCommand, PatientPresence } from '@dreryk/egabinet-appointment-frontend-api';
import { AppointmentId } from '@dreryk/egabinet-appointment-published-language-api';
import { VisitAndAppointmentViewQuery } from '@dreryk/egabinet-visit-frontend-api';

import { NonWaitingIcon, PreviewToggleButton, PreviewToggleButtonStates, WaitingIcon } from '@dreryk/react-components';
import { refetchCqrsQuery, useCqrsCommand } from '@dreryk/command-query-react-common';
import { useBoolean } from '@dreryk/react-common';

import { appointmentsTranslationKeys } from '../../../../translations';
import { isPatientPresenceFilterActive } from '../../../filters/AppointmentsFilterPanel/fields/PatientPresenceField/PatientPresenceField.utils';
import { isAppointmentConfirmationFilterActive } from '../../../filters/AppointmentsFilterPanel/fields/AppointmentConfirmationStatusField/AppointmentConfirmationStatusField.utils';

const t = appointmentsTranslationKeys;

const previewToggleButtonStates: PreviewToggleButtonStates = {
   on: {
      icon: <WaitingIcon />,
      tooltipContent: t.markPatientPresenceAsUnknown,
   },
   off: {
      icon: <NonWaitingIcon />,
      tooltipContent: t.markPatientPresenceAsWaiting,
   },
};

type PatientPresenceStatusProps = {
   patientPresence: PatientPresence;
   appointmentId: number;
};

export const PatientPresenceStatus = (props: PatientPresenceStatusProps): ReactElement => {
   const [{ setTrue: setPatientPresent, setFalse: setPatientNotPresent }, patientPresent] = useBoolean(
      props.patientPresence === 'PRESENT'
   );
   const { executeAsync: updateAppointmentConfirmationStatus } = useCqrsCommand<void, unknown>(
      () => {
         const command = new AppointmentUpdatePatientPresenceCommand();
         command.patientPresence = patientPresent ? 'UNKNOWN' : 'PRESENT';
         command.appointmentId = AppointmentId.of(props.appointmentId);
         return command;
      },
      {
         onSuccess: () => {
            if (isPatientPresenceFilterActive() || isAppointmentConfirmationFilterActive()) {
               refetchCqrsQuery(VisitAndAppointmentViewQuery);
            }
            if (patientPresent) {
               setPatientNotPresent();
               return;
            }
            setPatientPresent();
         },
      }
   );

   return (
      <PreviewToggleButton
         testId={'patientPresenceStatus'}
         value={patientPresent}
         states={previewToggleButtonStates}
         onClick={updateAppointmentConfirmationStatus}
      />
   );
};
